/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const memberBasicInfoDtoGenderIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');
export const memberBasicInfoDtoMemberStatusIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const MemberBasicInfoDto = zod.object({
  "id": zod.string().uuid().optional(),
  "firstName": zod.string().optional(),
  "lastName": zod.string().optional(),
  "middleName": zod.string().nullish(),
  "suffix": zod.string().nullish(),
  "fieldName": zod.string().optional(),
  "birthday": zod.coerce.date().nullish(),
  "genderId": zod.union([zod.number(),zod.string().regex(memberBasicInfoDtoGenderIdRegExpTwo)]).nullish(),
  "genderCode": zod.string().nullish(),
  "genderName": zod.string().nullish(),
  "contactNumber": zod.string().nullish(),
  "memberStatusId": zod.union([zod.number(),zod.string().regex(memberBasicInfoDtoMemberStatusIdRegExpTwo)]).nullish(),
  "memberStatusCode": zod.string().nullish(),
  "memberStatusName": zod.string().nullish()
});

export type MemberBasicInfoDto = zod.input<typeof MemberBasicInfoDto>;
export type MemberBasicInfoDtoOutput = zod.output<typeof MemberBasicInfoDto>;
